import { render, staticRenderFns } from "./Getters.vue?vue&type=template&id=0f24d435&"
import script from "./Getters.vue?vue&type=script&lang=js&"
export * from "./Getters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports